export default {
  data() {
    return {
      dashboardDisplayList: [],
      selectedDashboardDisplayId: "default",
      dashboardDisplayBeingUpdated: -1,
      isDashboardDisplayListOpen: false,
    };
  },
  computed: {
    hasDashboardDisplay() {
      return this.dashboardDisplayList.length > 0;
    },
    selectedDisplayStyle() {
      if (!this.hasDashboardDisplay || !this.isFullscreen) return {};
      const info = this.dashboardDisplayList.find(
        (i) => i.id == this.selectedDashboardDisplayId
      );
      if (!info) return {};
      const { gridTemplateRows, gridTemplateAreas, scale } = this.getGrid(info);
      return {
        "--num-of-cols": info.columns,
        "grid-template-rows": gridTemplateRows,
        "grid-template-areas": gridTemplateAreas,
        zoom: scale,
      };
    },
    groupsToShow() {
      const selected = this.dashboardDisplayList.find(
        (i) => i.id == this.selectedDashboardDisplayId
      );
      if (selected) {
        const ids = selected.groupsDisplays.map((g) => g.group.id);
        console.log(ids);
        let groups = this.groups.filter((g) => ids.includes(g.id));
        return groups;
      }

      return this.filterGroups(this.groups);
    },
  },
  methods: {
    filterGroups(groups) {
      if(this.filter == '') return groups;  
      return groups.filter(
        (group) => {
          return group.measurers.some((measure) =>
            measure.name.toLowerCase().includes(this.filter.toLowerCase())
          ) || group.name.toLowerCase().includes(this.filter.toLowerCase())
        }

      );
    },

    replaceSpecialChar(str) {
      if (str.search(/[\xC0-\xFF]/g) > -1) {
        str = str
          .replace(/[\xC0-\xC5]/g, "A")
          .replace(/[\xC6]/g, "AE")
          .replace(/[\xC7]/g, "C")
          .replace(/[\xC8-\xCB]/g, "E")
          .replace(/[\xCC-\xCF]/g, "I")
          .replace(/[\xD0]/g, "D")
          .replace(/[\xD1]/g, "N")
          .replace(/[\xD2-\xD6\xD8]/g, "O")
          .replace(/[\xD9-\xDC]/g, "U")
          .replace(/[\xDD]/g, "Y")
          .replace(/[\xDE]/g, "P")
          .replace(/[\xE0-\xE5]/g, "a")
          .replace(/[\xE6]/g, "ae")
          .replace(/[\xE7]/g, "c")
          .replace(/[\xE8-\xEB]/g, "e")
          .replace(/[\xEC-\xEF]/g, "i")
          .replace(/[\xF1]/g, "n")
          .replace(/[\xF2-\xF6\xF8]/g, "o")
          .replace(/[\xF9-\xFC]/g, "u")
          .replace(/[\xFE]/g, "p")
          .replace(/[\xFD\xFF]/g, "y");
      }
      return str.replace(/[^A-Z0-9]+/gi, "");
    },

    selectDashboardDisplay(id) {
      this.selectedDashboardDisplayId = id;
      const info = this.dashboardDisplayList.find((i) => i.id == id);
      console.log(info)
      this.zoomLevel =
        info && typeof info.zoom === "number" ? info.zoom * 100 : 100;
    },

    refreshZoom() {
      const info = this.dashboardDisplayList.find(
        (i) => i.id == this.selectedDashboardDisplayId
      );
      console.log("refresh zoom", info.zoom);
      this.zoomLevel =
        info && typeof info.zoom === "number" ? info.zoom * 100 : 100;
    },

    refreshDashboardDisplay(id) {
      if (this.dashboardDisplayBeingUpdated !== -1) return;

      this.dashboardDisplayBeingUpdated = id;
      this.dashboardDisplayService.search(id).then((res) => {
        res.zoom = res.zoom / 100;
        const idx = this.dashboardDisplayList.findIndex(
          (el) => el.id === res.id
        );
        if (idx !== -1) {
          this.selectDashboardDisplay("default");
          this.$nextTick(() => {
            const old = this.dashboardDisplayList[idx];
            let updatedGroupDisplay = this.updateGroupDisplay(
              res.groupsDisplays,
              old.groupsDisplays
            );
            res.dashboard = old.dashboard;
            res.groupsDisplays = updatedGroupDisplay;
            this.dashboardDisplayList.splice(idx, 1, res);
            this.selectDashboardDisplay(id);
            this.dashboardDisplayBeingUpdated = -1;
          });
        } else {
          this.dashboardDisplayBeingUpdated = -1;
        }
      });
    },
    updateGroupDisplay(groupDisplay, oldGroupDisplay) {
      const out = [];
      for (const display of groupDisplay) {
        const old = oldGroupDisplay.find((d) => d.id === display.id);
        if (old) out.push({ ...display, group: old.group });
      }
      return out;
    },
    generateGridArea(areas) {
      let gridTemplateAreas = "";
      const maxY = Math.max(...areas.map((a) => a.y + a.h));
      const cols =
        (
          this.dashboardDisplayList.find(
            (i) => i.id == this.selectedDashboardDisplayId
          ) || {}
        ).columns || 6;
      for (let i = 0; i < maxY; i++) {
        let row = "";
        for (let j = 0; j < cols; j++) {
          const found = areas.find(
            (a) => a.y <= i && i < a.y + a.h && a.x === j
          );
          if (found) {
            row += `${Array(found.w).fill(found.groupName).join(" ")} `;
            j += found.w - 1;
          } else row += ". ";
        }
        gridTemplateAreas += `"${row.trim()}" `;
      }
      return gridTemplateAreas.trim();
    },
    getGrid(display) {
      const groups = display.groupsDisplays.map((g) => {
        const groupEl = this.groups.find((gr) => gr.id == g.group.id);
        return groupEl
          ? { ...g, groupName: this.replaceSpecialChar(groupEl.name) }
          : { ...g, groupName: "Grupo" };
      });
      const gridTemplateRows = `${this.rowHeight}px`;
      const gridTemplateAreas = this.generateGridArea(groups);
      return {
        gridTemplateRows,
        gridTemplateAreas,
        scale: this.zoomLevel / 100,
      };
    },
    getNumberOfCols(group) {
      if (
        this.hasDashboardDisplay &&
        this.isFullscreen &&
        this.selectedDashboardDisplayId !== "default"
      ) {
        const info = this.dashboardDisplayList.find(
          (i) => i.id == this.selectedDashboardDisplayId
        );
        const groupEl = info?.groupsDisplays.find(
          (g) => g.group?.id == group.id
        );
        return groupEl ? groupEl.w : 6;
      }
      return 6;
    },
    getNumberOfRows(group) {
      if (
        this.hasDashboardDisplay &&
        this.isFullscreen &&
        this.selectedDashboardDisplayId !== "default"
      ) {
        const info = this.dashboardDisplayList.find(
          (i) => i.id == this.selectedDashboardDisplayId
        );
        const groupEl = info?.groupsDisplays.find(
          (g) => g.group?.id == group.id
        );
        return groupEl?.h;
      }
      return undefined;
    },
    getGroupPosition(group) {
      if (this.hasDashboardDisplay && this.isFullscreen) {
        return { "grid-area": this.replaceSpecialChar(group.name) };
      }
      return "";
    },
    toggleOpenFullscreenButtons() {
      const buttons = this.$el.querySelector(".dashboardFullScreenButtons");
      const indicator = this.$el.querySelector(".fullscreenIndicator");
      if (buttons) buttons.classList.toggle("open");
      if (indicator) indicator.classList.toggle("open");
    },
  },

  async mounted() {
    this.dashboardDisplayService = new this.$dashboardDisplayService();
    await this.dashboardDisplayService
      .searchByDashboardId(this.id)
      .then((res) => {
        const def = res.find((i) => i.name === "Default");
        if (def) def.id = "default";
        this.dashboardDisplayList = res.map((item) => ({
          ...item,
          zoom: item.zoom / 100,
        }));
      });

    if (this.initialDashboardDisplay)
      this.selectDashboardDisplay(this.initialDashboardDisplay);
  },
};
